export const UNITS = {
  cpu: 'cpu',
  bandwidth: 'bandwidth',
  storage: 'storage',
  ram: 'ram'
}
